
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { DropzoneComponent } from 'react-dropzone-component';
import "dropzone/dist/min/dropzone.min.css";
import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Autocomplete, TextField } from "@mui/material";
import { CategoryDto, QuizDto, SubCategoryDto, Subjects, subjects } from "types";
import MDInput from "components/MDInput";
import { useAppContext } from 'context/app-context';
import { VariantType } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Howl } from 'howler'
import MDEditor from 'components/MDEditor';
import { getQuiz, updateQuiz } from 'services/quiz-services';
import { getByCategory } from 'services/sub-category-services';
import { getUUIDFromKey, uploadS3Handler } from 'utils/helpers';
import { getMyCategoriesPerSubjectId } from 'services/category-services';

interface DropzoneType {
  removeFile: () => void;
  removeAllFiles: () => void;
  addFile: (arg0: any) => void;
  processQueue: () => void;
}
function EditCard(): JSX.Element {
  const [subCategoryValue, setSubCategoryValue] = useState<SubCategoryDto>({} as SubCategoryDto)
  const [newSubCategoryValue, setNewSubCategoryValue] = useState<SubCategoryDto>({} as SubCategoryDto)
  const [categoryValue, setCategoryValue] = useState<CategoryDto>({} as CategoryDto)
  const [subCategories, setSubCategories] = useState<SubCategoryDto[]>([] as SubCategoryDto[])
  const [categories, setCategories] = useState<CategoryDto[]>([] as CategoryDto[])
  const [pk, setPk] = useState<string>('')
  const [subjectValue, setSubjectValue] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true)
  const { quizCards, setQuizCards, handleMessage }: {
    quizCards: QuizDto[],
    setQuizCards: (quizzes: any[]) => void
    handleMessage: (message: string, variant: VariantType) => void
  } = useAppContext()
  const navigate = useNavigate()
  const location = useLocation()


  useEffect(() => {
    const list = location.pathname.split('/')
    const { [list.length - 1]: pathname } = list
    setPk(`QUIZ#${pathname}`)
  }, [location])


  useEffect(() => {
    if (quizCards.length && pk) {
      const editingQuizCard = quizCards.find(q => q.PK === pk)
      setSubjectValue(editingQuizCard.category.subject)
      setTitle(editingQuizCard.title)
      setDescription(editingQuizCard.description)
      setAnswer(editingQuizCard.answer)
    }
  }, [pk, quizCards])

  useEffect(() => {
    if (quizCards.length && pk && categories.length) {
      const editingQuizCard = quizCards.find(q => q.PK === pk)
      const category = categories.find(c => c.PK === editingQuizCard.category.category)
      setCategoryValue(category)
    }
  }, [pk, quizCards, categories])

  
  useEffect(() => {
    if (quizCards.length && pk && categories.length && subCategories.length) {
      const editingQuizCard = quizCards.find(q => q.PK === pk)
      const subcategory = subCategories.find(sub => sub.PK === editingQuizCard.subcategory.subcategory)
      setSubCategoryValue(subcategory)
      setNewSubCategoryValue(subcategory)
      setIsLoading(false)
    }
  }, [pk, quizCards, categories, subCategories])
  const [descriptionAudioFile, setDescriptionAudioFile] = useState('')
  const [descriptionImageFile, setDescriptionImageFile] = useState('')
  const [answerAudioFile, setAnswerAudioFile] = useState('')
  const [answerImageFile, setAnswerImageFile] = useState('')

  useEffect(() => {
    if (subCategoryValue && Object.keys(subCategoryValue).length) {
      (async () => {
        const quiz = await getQuiz(getUUIDFromKey(subCategoryValue.PK), getUUIDFromKey(pk))
        setDescriptionAudioFile(quiz.descriptionAudio)
        setDescriptionImageFile(quiz.descriptionImage)
        setAnswerAudioFile(quiz.answerAudio)
        setAnswerImageFile(quiz.answerImage)
      })()
    }
  }, [subCategoryValue, pk])


  const [imageDescriptionDropzone, setImageDescriptionDropzone] = useState<DropzoneType>({} as DropzoneType)
  const [audioDescriptionDropzone, setAudioDescriptionDropzone] = useState<DropzoneType>({} as DropzoneType)

  const [imageAnswerDropzone, setImageAnswerDropzone] = useState<DropzoneType>({} as DropzoneType)
  const [audioAnswerDropzone, setAudioAnswerDropzone] = useState<DropzoneType>({} as DropzoneType)

  function initImageDescriptionCallback(dropzone: any) {
    setImageDescriptionDropzone(dropzone);
  }

  function initImageAnswerCallback(dropzone: any) {
    setImageAnswerDropzone(dropzone);
  }

  function initAudioDescriptionCallback(dropzone: any) {
    setAudioDescriptionDropzone(dropzone);
  }

  function initAudioAnswerCallback(dropzone: any) {
    setAudioAnswerDropzone(dropzone);
  }

 
  const [inputSubjectValue, setSubjectInputValue] = useState<Subjects | ''>('');
  const [imageDescription, setImageDescription] = useState<File>({} as File)
  const [audioDescription, setAudioDescription] = useState<File>({} as File)
  const [imageAnswer, setImageAnswer] = useState<File>({} as File)
  const [audioAnswer, setAudioAnswer] = useState<File>({} as File)

  const [inputCategoryValue, setInputCategoryValue] = useState<string>('')
  const [inputSubCategoryValue, setInputSubCategoryValue] = useState<string>('')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [description, setDescription] = useState<string>('')
  const [title, setTitle] = useState<string>('')
  const [answer, setAnswer] = useState<string>('')

  useEffect(() => {
    if (subjectValue)
      (async () => {
        setCategories(await getMyCategoriesPerSubjectId(subjectValue))
      })()
  }, [subjectValue])


  useEffect(() => {
    if (categoryValue && Object.keys(categoryValue).length) {
      (async () => {
        setSubCategories(await getByCategory(getUUIDFromKey(categoryValue.PK)))
      })()
    }
  }, [categoryValue])



  const imageConfig = {
    iconFiletypes: ['.jpg', '.png', '.gif'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
  };

  const audioConfig = {
    iconFiletypes: ['.mp3', '.wav'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
  };

  const djsImageConfig = {
    maxFiles: 1,
    uploadMultiple: false,
    addRemoveLinks: true,
    acceptedFiles: "image/jpeg,image/png,image/gif",
    autoProcessQueue: false
  };

  const djsAudioConfig = {
    maxFiles: 1,
    uploadMultiple: false,
    addRemoveLinks: true,
    acceptedFiles: "audio/*",
    autoProcessQueue: false
  };

  const eventDescriptionImageHandlers = {
    init: (e: any) => initImageDescriptionCallback(e),
    addedfile: (file: any) => setImageDescription(file),
    maxfilesexceeded: (file: any) => {
      imageDescriptionDropzone.removeAllFiles();
      imageDescriptionDropzone.addFile(file);
    },
    removedfile: (file: any) => setImageDescription({} as File)
  }

  const eventDescriptionAudioHandlers = {
    init: (e: any) => initAudioDescriptionCallback(e),
    addedfile: (file: any) => setAudioDescription(file),
    maxfilesexceeded: (file: any) => {
      audioDescriptionDropzone.removeAllFiles();
      audioDescriptionDropzone.addFile(file);
    },
    removedfile: (file: any) => setAudioDescription({} as File)
  }

  const eventAnswerImageHandlers = {
    init: (e: any) => initImageAnswerCallback(e),
    addedfile: (file: any) => setImageAnswer(file),
    maxfilesexceeded: (file: any) => {
      imageAnswerDropzone.removeAllFiles();
      imageAnswerDropzone.addFile(file);
    },
    removedfile: (file: any) => setImageAnswer({} as File)
  }

  const eventAnswerAudioHandlers = {
    init: (e: any) => initAudioAnswerCallback(e),
    addedfile: (file: any) => setAudioAnswer(file),
    maxfilesexceeded: (file: any) => {
      audioAnswerDropzone.removeAllFiles();
      audioAnswerDropzone.addFile(file);
    },
    removedfile: (file: any) => setAudioAnswer({} as File)
  }

  const handleUpdateQuestion = async () => {
    try {
      const newCategoryPk = categoryValue.PK
      let file
      let files = [] as { type: string, filepath: string }[]
      const uuid = getUUIDFromKey(pk)
      if (imageDescription && Object.keys(imageDescription)?.length) {
        const { key } = await uploadS3Handler(`${uuid}/`, imageDescription)
        // imgDropzone.processQueue()
        file = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${uuid}/${key}`
        files = [...files, { type: 'descriptionImage', filepath: file }]
      }
      if (audioDescription && Object.keys(audioDescription).length) {
        const { key } = await uploadS3Handler(`${uuid}/`, audioDescription)
        // audioDropzone.processQueue()
        file = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${uuid}/${key}`
        files = [...files, { type: 'descriptionAudio', filepath: file }]
      }
      if (imageAnswer && Object.keys(imageAnswer).length) {
        const { key } = await uploadS3Handler(`${uuid}/`, imageAnswer)
        // audioDropzone.processQueue()
        file = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${uuid}/${key}`
        files = [...files, { type: 'answerImage', filepath: file }]
      }
      if (audioAnswer && Object.keys(audioAnswer).length) {
        const { key } = await uploadS3Handler(`${uuid}/`, audioAnswer)
        // audioDropzone.processQueue()
        file = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${uuid}/${key}`
        files = [...files, { type: 'answerAudio', filepath: file }]
      }
      const mappedFiles = Object.assign({}, ...files.map(f => ({ [Object.values(f)[0]]: Object.values(f)[1] })));
      
      const updatedQuiz = await updateQuiz(
        getUUIDFromKey(newSubCategoryValue.PK),
        uuid,
        { ...mappedFiles, category: newCategoryPk, description, title, answer }
      );
      quizCards.splice(quizCards.findIndex(q => q.PK === updatedQuiz.PK), 1,
        {
          ...updatedQuiz, //@ts-ignore
          category: { category: updatedQuiz.category, name: categoryValue.name, subject: subjectValue },//@ts-ignore
          subcategory: { name: newSubCategoryValue.name, grade: newSubCategoryValue.grade, subcategory: newSubCategoryValue.PK }
        });
      setQuizCards(quizCards)
      handleMessage(`Du har redigeret quizzen ${title}`, 'success')
      navigate('/cards/my-cards')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }
  // const id = "no-padding";

  const playSound = (src: string): void => {
    const sound = new Howl({
      src,
      html5: true
    })
    try {
      sound.play()
    } catch (error) {
      handleMessage("Der er ingen lyd til denne quiz", 'info')
    }
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card >
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight="medium">
            Edit Card {title}
          </MDTypography>
        </MDBox>
        <Grid container justifyContent={'center'}>
          <Grid item sm={12} lg={8} >
            <MDBox
              justifyContent='space-between'
              alignItems='center'
              display='flex'
              flexDirection='column'>
              <MDBox mt={1} px={2} width={"100%"}>
                <MDBox mt={1} px={2} max-width={500}>
                  {/* <Autocomplete
                    value={gradeValue}
                    onChange={(event: any, newValue: string | null) => {
                      setGradeValue(newValue);
                    }}
                    inputValue={inputGradeValue}
                    onInputChange={(event, newInputValue) => {
                      if (newInputValue === '') {
                        setCategories([])
                      }
                      setCategoryValue({} as CategoryDto)
                      setGradeInputValue(newInputValue);
                    }}
                    id="controllable-states-grades"
                    options={grades}
                    renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                  /> */}
                  <MDBox mt={1}>
                    <Autocomplete
                      noOptionsText="Ingen muligheder endnu"
                      value={subjectValue}
                      onChange={(event: any, newValue: string | null) => {
                        setSubjectValue(newValue);
                      }}
                      inputValue={inputSubjectValue}
                      onInputChange={(event: any, newInputValue) => {
                        if (newInputValue === '') {
                          // setCategoryNames([])
                          // setCategories([])
                        }
                        setCategoryValue({} as CategoryDto)
                        setSubjectInputValue(newInputValue);
                      }}
                      id="controllable-states-subjects"
                      options={subjects}
                      renderInput={(params) => <TextField {...params} label="Fag" />}
                    />
                  </MDBox>
                  <MDBox mt={1}>
                    <Autocomplete
                      noOptionsText="Ingen muligheder endnu"
                      value={categoryValue}
                      getOptionLabel={(option) => (option as CategoryDto).name || ""}
                      //@ts-ignore
                      onChange={(event: any, newValue: CategoryDto | null) => {
                        setCategoryValue(newValue);
                      }}
                      inputValue={inputCategoryValue}
                      onInputChange={(event, newInputValue) => {
                        setInputCategoryValue(newInputValue);
                      }}
                      id="controllable-states-categories"
                      options={categories}
                      renderInput={(params) => <TextField {...params} label="Hovedkategori" />}
                    />
                  </MDBox>
                  <MDBox mt={1}>
                    <Autocomplete
                      noOptionsText="Ingen muligheder endnu"
                      value={newSubCategoryValue}
                      getOptionLabel={(option) => (option as SubCategoryDto).name || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: SubCategoryDto | null) => {
                        setNewSubCategoryValue(newValue);
                      }}
                      inputValue={inputSubCategoryValue}
                      onInputChange={(event, newInputValue) => {
                        setInputSubCategoryValue(newInputValue);
                      }}
                      id="controllable-states-subjects"
                      options={subCategories}
                      renderInput={(params) => <TextField {...params} label="Quiz-kategori" />}
                    />
                  </MDBox>
                  <MDBox mt={1}>
                    <Card>
                      <MDBox mt={1} px={2}>
                        <MDInput
                          fullWidth
                          label="Titel"
                          value={title}
                          onChange={(e: any) => setTitle(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={1} px={2}>
                        <MDTypography variant='h6' fontWeight='light'>Quiz-spørgsmål</MDTypography>
                        <MDEditor isEditing={true} value={description} onChange={setDescription} />
                      </MDBox>
                      <Grid container>
                        <Grid item sm={12} lg={6} >
                          <MDBox mt={1} px={2}>
                            <MDTypography variant='h6' fontWeight='light'>Vælg et billede til beskrivelsen</MDTypography>
                            <Grid container>
                              <Grid item sm={2}>
                                <Zoom>
                                  {descriptionImageFile && <img
                                    style={{ maxWidth: 50, width: "auto" }}
                                    alt="quiz img"
                                    src={descriptionImageFile}
                                  />}
                                </Zoom>
                              </Grid>
                              <Grid item sm={10}>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventDescriptionImageHandlers}
                                  config={imageConfig}
                                  djsConfig={djsImageConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>
                              </Grid>
                            </Grid>
                          </MDBox></Grid>
                        <Grid item sm={12} lg={6} >
                          <MDBox mt={1} px={2}>
                            <MDTypography variant='h6' fontWeight='light'>Vælg en lydfil til beskrivelsen</MDTypography>
                            <Grid container>
                              <Grid item sm={2}>
                                {descriptionAudioFile && <MDButton onClick={() => playSound(descriptionAudioFile)}>Play current audio</MDButton>}
                              </Grid>
                              <Grid item sm={10}>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventDescriptionAudioHandlers}
                                  config={audioConfig}
                                  djsConfig={djsAudioConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>
                              </Grid>
                            </Grid>
                          </MDBox>
                        </Grid>
                      </Grid>
                      <MDBox mt={1} px={2}>
                        <MDTypography variant='h6' fontWeight='light'>Svar</MDTypography>
                        <MDEditor isEditing={true} value={answer} onChange={setAnswer} />
                      </MDBox>
                      <Grid container>
                        <Grid item sm={12} lg={6} >
                          <MDBox mt={1} px={2}>
                            <MDTypography variant='h6' fontWeight='light'>Vælg et billede til beskrivelsen</MDTypography>
                            <Grid container>
                              <Grid item sm={2}>
                                <Zoom>
                                  {answerImageFile && <img
                                    style={{ maxWidth: 50, width: "auto" }}
                                    alt="quiz img"
                                    src={answerImageFile}
                                  />}
                                </Zoom>
                              </Grid>
                              <Grid item sm={10}>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventAnswerImageHandlers}
                                  config={imageConfig}
                                  djsConfig={djsImageConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>
                              </Grid>
                            </Grid>
                          </MDBox></Grid>
                        <Grid item sm={12} lg={6} >
                          <MDBox mt={1} px={2}>
                            <MDTypography variant='h6' fontWeight='light'>Vælg en lydfil til beskrivelsen</MDTypography>
                            <Grid container>
                              <Grid item sm={2}>
                                {answerAudioFile && <MDButton onClick={() => playSound(answerAudioFile)}>Play current audio</MDButton>}
                              </Grid>
                              <Grid item sm={10}>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventAnswerAudioHandlers}
                                  config={audioConfig}
                                  djsConfig={djsAudioConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>
                              </Grid>
                            </Grid>
                          </MDBox>
                        </Grid>
                      </Grid>
                      <MDBox p={3} px={10} mx='auto'>
                        <MDButton disabled={isLoading} onClick={handleUpdateQuestion} color='info'>Gem dine rettelser</MDButton>
                      </MDBox>
                    </Card>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid></Grid>
      </Card >
    </DashboardLayout >
  );
}


export default EditCard;
